import React, { Component, useContext, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonClose, ButtonDownload, ButtonCancel, ButtonModify } from '../../../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../../../layouts';
import Welcome from '../../../../layouts/welcome';
import Row from '../../../../components/row';
import Container from '../../../../layouts/containers/container';
import List from '../../../../components/list';
import ContainerTable from '../../../../layouts/containers/container-table';
import { stringToFriendlyDatetime, getDSTLocalTime } from '../../../../lib/helpers/datetime-helpers';
import LabelContainer from '../../../../components/label-container';
import Divider from '../../../../components/divider/divider';
import PopupContext from '../../../../context/context-popup';
import eventsApi from '../../../../lib/events/events-api';
import PopupsCancelBooking from '../../popups/popups-cancel-booking';
import StatusBar from '../../../../components/status-bar';
import Blurred from '../../../../components/blurred';
import PopupsAttendeesDynamic from '../../popups/popups-attendees-dynamic';
import MediaHelper from '../../../../lib/helpers/media';
import ReactToPrint from 'react-to-print';
import BillingDetails from '../../../../components/billing-profile';

const YourDetails = ({ booker }) => {
    const Item = ({ title, value }) => {
        return (
            <List gap='10px' style={{ flex: '1 0 0' }}>
                <LabelContainer label={title}>
                    { value }
                </LabelContainer>
            </List>
        )
    }

    const Flex = ({ direction, children }) => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: direction,
                gap: '20px',
            }}>
                { children }
            </div>
        )
    }

    const profile = booker?.billing_profile;

    return (
        <Container>
            <Container.Header>
                <Container.Text color="#FF6933" fontSize="18px">Your Billing Details</Container.Text>
            </Container.Header>

            <Container.Content>
                <Flex direction="column">
                    <Flex direction="row">
                        <Item title="First Name" value={profile?.first_name}/>
                        <Item title="Last Name" value={profile?.last_name}/>
                    </Flex>
                    <Flex direction="row">
                        <Item title="Company" value={profile?.company_name}/>
                    </Flex>
                    <Item title="Email Address" value={profile?.email_address}/>
                    <Flex direction="row">
                        <Item title="Telephone Number" value={profile?.tel_no}/>
                        <Item title="SAP Number" value={profile?.sap_number}/>
                    </Flex>
                </Flex>
            </Container.Content>
        </Container>
    )
}

const Summary = ({
    costs = null,
    receipt = null,
}) => {
    const data = []

    if (costs !== null || receipt !== null) {
        const items = costs?.saved_quote_line_items || receipt?.receipt_line_items;

       items?.forEach((item, index) => {
            let cost = `£${item?.total}`;

            data.unshift([
                item?.quantity,
                item?.description,
                cost,
            ])
        })
    }

    return (
        <ContainerTable
            showMobileColumns
            headerColor="#d5d5d5"
            valueColor='white'
            className="table-white"
            columns={[
                { field: 'QTY', width: '25%' },
                { field: 'Item', width: '50%' },
                { field: 'Price', width: '25%' },
            ]}
            data={[
                ...data
            ]}
        />
    )
}

const Buttons = ({ event, booking }) => {
    const { setPopup } = useContext(PopupContext);

    const cancel = () => {
        setPopup(<PopupsCancelBooking event={event} booking={booking}/>);
    }

    return (
        <>
            <ButtonClose responsive href="/mydmc/events">Close</ButtonClose>
            { booking?.cancelled === null && <ButtonCancel responsive onClick={cancel}>Cancel</ButtonCancel>  }
        </>
    )
}

const Attendees = ({ printScreen = false, refresh, attendees, howManyTicketsLeftMapped, event, booking }) => {
    const { setPopup } = useContext(PopupContext);

    const showAttendees = () => {
        setPopup(<PopupsAttendeesDynamic refresh={refresh} event={event} booking={booking} attendees={attendees} howManyTicketsLeftMapped={howManyTicketsLeftMapped}/>);
    }

    return (
        <List gap="20px">
            { attendees?.map((type, index) => {
                const name = type?.attendee_type === "App\\Models\\User" ? type?.attendee?.name : `${type?.attendee?.first_name} ${type?.attendee?.last_name}`;
                return <p>{index + 1 } - {name} - Ticket: {type?.event_ticket_type?.name}</p>;
            })}

            { printScreen === false && <ButtonModify onClick={showAttendees}>Attendee Information</ButtonModify> }
        </List>
    )
}

class BookingPrintSummary extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const quote = this.props.booking?.receipt || this.props.booking?.saved_quote;
        const feature_image = MediaHelper.formatPublicPath(`/images/${this.props.event?.content?.feature_image?.[0]?.file_name}`);

        return (
            <MinMaxLayout
                className={this.props.className}
                main={
                    <List gap="40px">
                        { this.props.booking?.cancelled !== null && <StatusBar
                            status="error"
                            head="Booking Cancelled"
                            content={
                                <p>
                                    This booking has been cancelled on <b>{ getDSTLocalTime(this.props.booking?.cancelled).format('HH:mm D/M/YYYY') }</b> by <b>{ this.props.booking?.cancelled_by?.name || 'Unknown '}</b>
                                </p>
                            }
                        /> }

                        <Blurred toggled={this.props.booking?.cancelled !== null}>
                            <div className="booking-view">
                                <List gap="40px" divider={<Divider/>} className="booking-view__child">
                                    <Container>
                                        <Container.Header>
                                            <Container.Text color="#FF6933" fontSize="18px">Booking Details</Container.Text>
                                        </Container.Header>

                                        <Container.Content> 
                                            <List gap="20px">
                                                <div className="booking-view__image" style={{ backgroundImage: `url('${feature_image}')` }}></div>

                                                <LabelContainer label='Event Name'>
                                                    { this.props.event?.name }
                                                </LabelContainer>

                                                <LabelContainer label="Booking Date & Duration">
                                                    { getDSTLocalTime(this.props.event?.start).format('HH:mm A') } - { getDSTLocalTime(this.props.event?.start).add(this.props.event?.duration_mins, 'minutes').format('HH:mm A - DD/MM/YYYY') }
                                                </LabelContainer>

                                                <LabelContainer label='Number Of Attendees'>
                                                    <Attendees
                                                        printScreen={this.props.printScreen}
                                                        refresh={this.props.fetchBooking}
                                                        howManyTicketsLeftMapped={this.props.howManyTicketsLeftMapped()}
                                                        attendees={this.props.booking?.event_attendees}
                                                        event={this.props.event}
                                                        booking={this.props.booking}
                                                    />
                                                </LabelContainer>

                                                <LabelContainer label='Booking Location'>
                                                    <Container.Text html={ this.props.event?.content?.location }/>
                                                </LabelContainer>
                                            </List>
                                        </Container.Content>
                                    </Container>

                                    <BillingDetails
                                        viewOnly
                                        booker={quote?.billing_profile}
                                    />
                                </List>

                                <Container className="booking-view__child">
                                    <Container.Header>
                                        <Container.Text color="#FF6933" fontSize="18px">Your Order</Container.Text>
                                    </Container.Header>

                                    <Container.Content>
                                        <List gap="40px">
                                            <div className="agree-box">
                                                <Summary
                                                    costs={this.props.booking?.saved_quote}
                                                    receipt={this.props.booking?.receipt}
                                                />
                                                <div className="agree-box__content">
                                                    <div className="agree-box__details">
                                                        <div className="agree-box-details__detail">
                                                            <p>BACS Due</p>
                                                            <span>£{ quote?.total }</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <Container>
                                                <Container.Header>
                                                    <Container.Text fontSize="18px" color="#FF6933">Booking Information</Container.Text>
                                                </Container.Header>

                                                <Container.Content className="booking-summary__text">
                                                    <Container.Text fontSize="14px" lightThemeColor="#24191F" darkThemeColor="white" html={`${this.props.event?.booking_information}`}></Container.Text>
                                                </Container.Content>
                                            </Container>

                                            <Container>
                                                <Container.Header>
                                                    <Container.Text fontSize="18px" color="#FF6933">Contact Us</Container.Text>
                                                </Container.Header>

                                                <Container.Content className="booking-summary__text">
                                                    <Container.Text fontSize="14px" color="#24191F" html={this.props.event?.content?.contact_details}/>
                                                </Container.Content>
                                        </Container>
                                        </List>
                                    </Container.Content>
                                </Container>
                            </div>
                        </Blurred>
                    </List>
                }
            />
        )
    }
}

class EventsView extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);

        this.state = {
           event: null,
           booking: null,
           printScreen: false,
        }

        this.componentRef = null;
    }

    componentDidMount() {
        this.fetchEvent();
        this.fetchBooking();
    }

    fetchEvent() {
        eventsApi.getEvent(this.props.id).then(({ data }) => {
            this.setState({ event: data });
        });
    }

    fetchBooking() {
        eventsApi.getEventBooking(this.props.id, this.props.bookingId).then(({ data }) => {
            this.setState({ booking: data });
        })
    }

    howManyTicketsLeft() {
        const tickets = this.state.booking?.event_ticket_type_bookings || [];

        const attendeesAssignedTickets = this.state.booking?.event_attendees?.
            filter(attendee => attendee.event_ticket_type_id !== undefined && attendee.event_ticket_type_id !== null) || [];

        const ticketUsageCount = tickets?.reduce((count, ticket) => {
            const selectedTicketId = ticket.event_ticket_type_id;
            const quantity = ticket.quantity;
        
            count[selectedTicketId] = quantity;
            
            attendeesAssignedTickets.forEach(attendee => {
                if (attendee.event_ticket_type_id === selectedTicketId) {
                    count[selectedTicketId]--;
                }
            });
            
            return count;
        }, {});

        return ticketUsageCount;
    }

    howManyTicketsLeftMapped() {
        const ticketsLeft = this.howManyTicketsLeft();
        const tickets = this.state.event?.event_ticket_types || [];

        return tickets?.map(ticket => {
            return {        
                ...ticket,
                left: ticketsLeft?.[ticket?.id]
            }
        })
    }

    render() {
        return (
            <Layout 
                theme="dark"
                loading={this.state.booking === null}
                topLeft={<Welcome title={<Container.Text>
                    <Row gap='10px' wrap>
                        Event Booking: <Container.Text color="#FF6933">#{ this.state.booking?.id }</Container.Text>
                    </Row>
                </Container.Text>} subtitle={this.state.event?.name}/>}
                topRight={
                    <Row gap="20px" wrap>
                        <Buttons event={this.state.event} booking={this.state.booking}/>

                        <ReactToPrint
                            trigger={() => {
                                return <ButtonDownload responsive>Print</ButtonDownload>
                            }}
                            content={() => this.componentRef}
                            onBeforePrint={() => {
                                return new Promise((resolve, reject) => {
                                    this.setState({ printScreen: false }, () => resolve());
                                });
                            }}
                            onBeforeGetContent={() => {
                                return new Promise((resolve, reject) => {
                                  this.setState({ printScreen: true }, () => resolve());
                                });
                            }}

                            bodyClass="booking-summary"
                        />
                    </Row>
                }
            >
                <BookingPrintSummary
                    className={this.state.printScreen ? 'booking-summary' : ''}
                    printScreen={this.state.printScreen}
                    ref={ref => this.componentRef = ref}
                    booking={this.state.booking}
                    event={this.state.event}
                    howManyTicketsLeftMapped={this.howManyTicketsLeftMapped.bind(this)}
                    fetchBooking={this.fetchBooking.bind(this)}
                />
            </Layout>    
        )
    }
}

const el = document.getElementById('events-view');

if (el) {
    ReactDOM.render(<EventsView id={el.getAttribute('data-id')} bookingId={el.getAttribute('data-booking-id')}/>, el);
}
